// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MetricFieldsFragment = { __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } };

export type GetMetricQueryVariables = Types.Exact<{
  metricParams: Types.MetricParams;
}>;


export type GetMetricQuery = { __typename?: 'Query', getMetric: { __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } } };

export type GetTimeseriesMetricQueryVariables = Types.Exact<{
  metricParams: Types.MetricParams;
}>;


export type GetTimeseriesMetricQuery = { __typename?: 'Query', getTimeseriesMetric: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }> };

export type GetMetricsByOutfitterAndKeysQueryVariables = Types.Exact<{
  metricParams: Types.MetricByOutfitterAndKeysParams;
}>;


export type GetMetricsByOutfitterAndKeysQuery = { __typename?: 'Query', getMetricsByOutfitterAndKeys: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }> };

export type OutfitterWebsiteTrackingMetricsQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  dateRange: Types.DateRange;
}>;


export type OutfitterWebsiteTrackingMetricsQuery = { __typename?: 'Query', outfitterWebsiteTrackingMetrics: { __typename?: 'OutfitterWebsiteTrackingMetrics', page_views: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }>, total_users: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }>, new_users: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }>, sessions: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }>, time_series: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }>, avg_session_duration: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }>, new_users_percentage: { __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } } } };

export type OutfitterWebsiteTrackingAggregatedDataQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  dateRange: Types.DateRange;
}>;


export type OutfitterWebsiteTrackingAggregatedDataQuery = { __typename?: 'Query', outfitterWebsiteTrackingAggregatedData: { __typename?: 'OutfitterWebsiteTrackingAggregatedData', top_pages: Array<{ __typename?: 'PageRouteMetric', route: string, session_count: number }>, device_type_breakdown: { __typename?: 'DeviceTypeBreakdown', mobile: { __typename?: 'DeviceCounts', total: number, ios?: number | null, android?: number | null, macos?: number | null, windows?: number | null, linux?: number | null, other?: number | null }, desktop: { __typename?: 'DeviceCounts', total: number, ios?: number | null, android?: number | null, macos?: number | null, windows?: number | null, linux?: number | null, other?: number | null }, tablet: { __typename?: 'DeviceCounts', total: number, ios?: number | null, android?: number | null, macos?: number | null, windows?: number | null, linux?: number | null, other?: number | null } }, top_referrers: Array<{ __typename?: 'ReferrerMetric', referrer: string, session_count: number, new_user_count: number }> } };

export const MetricFieldsFragmentDoc = gql`
    fragment MetricFields on Metric {
  id
  label
  description
  value
  formatted_value
  metric_key
  metric_bucket
  date_timestamp
  delta {
    change
    change_type
  }
  created_at
  updated_at
}
    `;
export const GetMetricDocument = gql`
    query getMetric($metricParams: MetricParams!) {
  getMetric(metricParams: $metricParams) {
    ...MetricFields
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useGetMetricQuery__
 *
 * To run a query within a React component, call `useGetMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricQuery({
 *   variables: {
 *      metricParams: // value for 'metricParams'
 *   },
 * });
 */
export function useGetMetricQuery(baseOptions: Apollo.QueryHookOptions<GetMetricQuery, GetMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricQuery, GetMetricQueryVariables>(GetMetricDocument, options);
      }
export function useGetMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricQuery, GetMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricQuery, GetMetricQueryVariables>(GetMetricDocument, options);
        }
export type GetMetricQueryHookResult = ReturnType<typeof useGetMetricQuery>;
export type GetMetricLazyQueryHookResult = ReturnType<typeof useGetMetricLazyQuery>;
export type GetMetricQueryResult = Apollo.QueryResult<GetMetricQuery, GetMetricQueryVariables>;
export const GetTimeseriesMetricDocument = gql`
    query getTimeseriesMetric($metricParams: MetricParams!) {
  getTimeseriesMetric(metricParams: $metricParams) {
    ...MetricFields
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useGetTimeseriesMetricQuery__
 *
 * To run a query within a React component, call `useGetTimeseriesMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeseriesMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeseriesMetricQuery({
 *   variables: {
 *      metricParams: // value for 'metricParams'
 *   },
 * });
 */
export function useGetTimeseriesMetricQuery(baseOptions: Apollo.QueryHookOptions<GetTimeseriesMetricQuery, GetTimeseriesMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeseriesMetricQuery, GetTimeseriesMetricQueryVariables>(GetTimeseriesMetricDocument, options);
      }
export function useGetTimeseriesMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeseriesMetricQuery, GetTimeseriesMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeseriesMetricQuery, GetTimeseriesMetricQueryVariables>(GetTimeseriesMetricDocument, options);
        }
export type GetTimeseriesMetricQueryHookResult = ReturnType<typeof useGetTimeseriesMetricQuery>;
export type GetTimeseriesMetricLazyQueryHookResult = ReturnType<typeof useGetTimeseriesMetricLazyQuery>;
export type GetTimeseriesMetricQueryResult = Apollo.QueryResult<GetTimeseriesMetricQuery, GetTimeseriesMetricQueryVariables>;
export const GetMetricsByOutfitterAndKeysDocument = gql`
    query getMetricsByOutfitterAndKeys($metricParams: MetricByOutfitterAndKeysParams!) {
  getMetricsByOutfitterAndKeys(metricParams: $metricParams) {
    ...MetricFields
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useGetMetricsByOutfitterAndKeysQuery__
 *
 * To run a query within a React component, call `useGetMetricsByOutfitterAndKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsByOutfitterAndKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsByOutfitterAndKeysQuery({
 *   variables: {
 *      metricParams: // value for 'metricParams'
 *   },
 * });
 */
export function useGetMetricsByOutfitterAndKeysQuery(baseOptions: Apollo.QueryHookOptions<GetMetricsByOutfitterAndKeysQuery, GetMetricsByOutfitterAndKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricsByOutfitterAndKeysQuery, GetMetricsByOutfitterAndKeysQueryVariables>(GetMetricsByOutfitterAndKeysDocument, options);
      }
export function useGetMetricsByOutfitterAndKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsByOutfitterAndKeysQuery, GetMetricsByOutfitterAndKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricsByOutfitterAndKeysQuery, GetMetricsByOutfitterAndKeysQueryVariables>(GetMetricsByOutfitterAndKeysDocument, options);
        }
export type GetMetricsByOutfitterAndKeysQueryHookResult = ReturnType<typeof useGetMetricsByOutfitterAndKeysQuery>;
export type GetMetricsByOutfitterAndKeysLazyQueryHookResult = ReturnType<typeof useGetMetricsByOutfitterAndKeysLazyQuery>;
export type GetMetricsByOutfitterAndKeysQueryResult = Apollo.QueryResult<GetMetricsByOutfitterAndKeysQuery, GetMetricsByOutfitterAndKeysQueryVariables>;
export const OutfitterWebsiteTrackingMetricsDocument = gql`
    query outfitterWebsiteTrackingMetrics($outfitterId: ID!, $dateRange: DateRange!) {
  outfitterWebsiteTrackingMetrics(
    outfitterId: $outfitterId
    dateRange: $dateRange
  ) {
    page_views {
      ...MetricFields
    }
    total_users {
      ...MetricFields
    }
    new_users {
      ...MetricFields
    }
    sessions {
      ...MetricFields
    }
    time_series {
      ...MetricFields
    }
    avg_session_duration {
      ...MetricFields
    }
    new_users_percentage {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useOutfitterWebsiteTrackingMetricsQuery__
 *
 * To run a query within a React component, call `useOutfitterWebsiteTrackingMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutfitterWebsiteTrackingMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutfitterWebsiteTrackingMetricsQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useOutfitterWebsiteTrackingMetricsQuery(baseOptions: Apollo.QueryHookOptions<OutfitterWebsiteTrackingMetricsQuery, OutfitterWebsiteTrackingMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutfitterWebsiteTrackingMetricsQuery, OutfitterWebsiteTrackingMetricsQueryVariables>(OutfitterWebsiteTrackingMetricsDocument, options);
      }
export function useOutfitterWebsiteTrackingMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutfitterWebsiteTrackingMetricsQuery, OutfitterWebsiteTrackingMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutfitterWebsiteTrackingMetricsQuery, OutfitterWebsiteTrackingMetricsQueryVariables>(OutfitterWebsiteTrackingMetricsDocument, options);
        }
export type OutfitterWebsiteTrackingMetricsQueryHookResult = ReturnType<typeof useOutfitterWebsiteTrackingMetricsQuery>;
export type OutfitterWebsiteTrackingMetricsLazyQueryHookResult = ReturnType<typeof useOutfitterWebsiteTrackingMetricsLazyQuery>;
export type OutfitterWebsiteTrackingMetricsQueryResult = Apollo.QueryResult<OutfitterWebsiteTrackingMetricsQuery, OutfitterWebsiteTrackingMetricsQueryVariables>;
export const OutfitterWebsiteTrackingAggregatedDataDocument = gql`
    query outfitterWebsiteTrackingAggregatedData($outfitterId: ID!, $dateRange: DateRange!) {
  outfitterWebsiteTrackingAggregatedData(
    outfitterId: $outfitterId
    dateRange: $dateRange
  ) {
    top_pages {
      route
      session_count
    }
    device_type_breakdown {
      mobile {
        total
        ios
        android
        macos
        windows
        linux
        other
      }
      desktop {
        total
        ios
        android
        macos
        windows
        linux
        other
      }
      tablet {
        total
        ios
        android
        macos
        windows
        linux
        other
      }
    }
    top_referrers {
      referrer
      session_count
      new_user_count
    }
  }
}
    `;

/**
 * __useOutfitterWebsiteTrackingAggregatedDataQuery__
 *
 * To run a query within a React component, call `useOutfitterWebsiteTrackingAggregatedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutfitterWebsiteTrackingAggregatedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutfitterWebsiteTrackingAggregatedDataQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useOutfitterWebsiteTrackingAggregatedDataQuery(baseOptions: Apollo.QueryHookOptions<OutfitterWebsiteTrackingAggregatedDataQuery, OutfitterWebsiteTrackingAggregatedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutfitterWebsiteTrackingAggregatedDataQuery, OutfitterWebsiteTrackingAggregatedDataQueryVariables>(OutfitterWebsiteTrackingAggregatedDataDocument, options);
      }
export function useOutfitterWebsiteTrackingAggregatedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutfitterWebsiteTrackingAggregatedDataQuery, OutfitterWebsiteTrackingAggregatedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutfitterWebsiteTrackingAggregatedDataQuery, OutfitterWebsiteTrackingAggregatedDataQueryVariables>(OutfitterWebsiteTrackingAggregatedDataDocument, options);
        }
export type OutfitterWebsiteTrackingAggregatedDataQueryHookResult = ReturnType<typeof useOutfitterWebsiteTrackingAggregatedDataQuery>;
export type OutfitterWebsiteTrackingAggregatedDataLazyQueryHookResult = ReturnType<typeof useOutfitterWebsiteTrackingAggregatedDataLazyQuery>;
export type OutfitterWebsiteTrackingAggregatedDataQueryResult = Apollo.QueryResult<OutfitterWebsiteTrackingAggregatedDataQuery, OutfitterWebsiteTrackingAggregatedDataQueryVariables>;